import { SchemaType } from '../type';
export const schema = {
    id: 'project_auth_appids',
    name: '授权数据库',
    identityField: 'appId',
    type: SchemaType.Indivisible,
};
